import React from "react";
import {
  Image,
  Platform,
  StyleProp,
  ImageStyle,
  ViewStyle,
} from "react-native";
import { SvgXml } from "react-native-svg";

type Props = {
  svg: string;
  width?: number;
  height?: number;
  style?: StyleProp<ImageStyle | ViewStyle>;
};

export function SvgIcon({ svg, width = 22, height = 22, style }: Props) {
  if (Platform.OS === "web") {
    const uri = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
    return (
      <Image
        source={{ uri }}
        style={[{ width, height }, style as ImageStyle]}
        resizeMode="contain"
      />
    );
  }
  return (
    <SvgXml xml={svg} width={width} height={height} style={style as any} />
  );
}

export default SvgIcon;
